import IQOSAnswers from './IQOSAnswers';
export default IQOSAnswers;